import * as types from "../actions/actionTypes";
import * as eventTypes from "../actions/eventTypes";
import initialState from "./initialState";
import { env } from "utils/env";

export default function userInfoReducer(state = initialState.userInfo, action) {
  switch (action.type) {
    case types.LOAD_USER_INFO_STARTED:
      return Object.assign({}, action.payload, { isLoaded: false, loading: true, error: false });

    case types.LOAD_USER_INFO_SUCCESS:
      return Object.assign({}, action.payload, { isLoaded: true, loading: false, error: false });

    case types.LOAD_USER_INFO_FAILED:
      return Object.assign({}, { isLoaded: false, loading: false, error: true });

    case types.INVALIDATE_USER_INFO:
      return Object.assign({}, { isLoaded: false, loading: false, error: false });

    case eventTypes.IDENTITY_USER_CHANGED: {
      if (!JSON.parse(env.USE_LOGOUT_PROVIDER)) return { ...state };
      else
        return {
          ...initialState.userInfo
        };
    }

    default:
      return state;
  }
}
